import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import { AlreadyLoginPage } from 'pages';
import { LicensePrice } from 'components';

class CtLicensePrice extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {}

  render() {
    const { isAuth, location, history } = this.props;

    // if (isAuth === 1) {
    //   // 이미 로그인 된 상태로 접속
    //   if (this.state.alreadLogin) {
    //     // 만약 로그인 된 상태에서 root로 넘어왔을경우 main으로 이동
    //     if (location.pathname !== '/intro') {
    //       const toPath = location.pathname === '/' ? '/main' : location.pathname;
    //       return <Redirect to={toPath} />;
    //     }

    //     return <AlreadyLoginPage accessLevel={1} />;
    //   }
    // }

    // // 로그인 안된 상태에서 root로 들어온 경우 url을 변경해준다.
    // if (location.pathname !== '/intro') {
    //   history.replace('/intro');
    // }

    return <LicensePrice />;
  }
}

const mapStateToProps = state => ({
  isAuth: state.user.get('isAuth')
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CtLicensePrice);



// WEBPACK FOOTER //
// ./src/script/containers/intro/CtLicensePrice.js